import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './baseQuery';

/**
 * The single RTK Query API slice. Every domain's endpoints are injected into this one.
 *
 * `@rtk-query/codegen-openapi` generates into `src/api/generated/*`, one file per tag, each
 * calling `baseApi.injectEndpoints(...)`. That satisfies the brief's per-domain service-file
 * requirement without a separate store slice, reducer or middleware per domain — there is one
 * cache, so two screens asking for the same data share one request.
 *
 * Tag types are declared here rather than in the generated files, because invalidation is a
 * frontend concern the OpenAPI spec knows nothing about. Adding a domain means adding its tag
 * here and regenerating.
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Authentication',
    'Account',
    'Customers',
    'Orders',
    'Order chat',
    'Customer order chat',
  ],
  // Grids are long-lived screens and customers reply while they are open.
  refetchOnMountOrArgChange: 30,
  refetchOnReconnect: true,
  endpoints: () => ({}),
});
